<template>
  <div class="event-banners">
    <v-carousel
      v-if="slides.length"
      class="pa-0 event-banners__carousel"
      cycle
      height="100%"
      hide-delimiters
      :show-arrows="slides.length > 1"
    >
      <v-carousel-item
        v-for="slide in slides"
        :key="slide.bannerId || slide.imageUrl"
        :href="slide.linkUrl || undefined"
        :target="slide.target || undefined"
        eager
      >
        <v-img
          :src="slide.imageUrl"
          class="event-banners__image"
          height="100%"
          eager
          contain
        />
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      loading: true,
      errored: false,
      currentCategoryId: 1,
      slides: []
    }
  },
  async mounted () {
    await this.loadBanners()
  },
  methods: {
    async loadBanners() {
      axios ({
        method: 'get',
        url: this.getBannersApiUrl(),
        headers: await this.getHeaders()
      })
        .then((response) => {
          const banners = response.data[0].banners
            .filter((banner) => banner.imageUrl)
            .sort((a, b) => Number(a.orderId) - Number(b.orderId))

          return this.preloadImages(banners.map((banner) => banner.imageUrl))
            .finally(() => {
              this.slides = banners
            })
        })
        .catch((error) => {
          console.log(error)
          this.errored = true
        })
        .finally(() => this.loading = false)
    },
    preloadImages(imageUrls) {
      return Promise.all(imageUrls.map((imageUrl) => new Promise((resolve) => {
        const image = new Image()

        image.onload = resolve
        image.onerror = resolve
        image.src = imageUrl
      })))
    },
    async getHeaders() {
      const accessToken = await this.$msal.acquireToken()

      return {
        Authorization: 'Bearer ' + accessToken,
        'x-functions-key': process.env.VUE_APP_BANNERS_API_KEY
      }
    },
    getBannersApiUrl() {
      return `${process.env.VUE_APP_BANNERS_API_URL}banners/${process.env.VUE_APP_BANNERS_API_ENTITY}/${this.currentCategoryId}`
    }
  }
}
</script>

<style scoped>
.event-banners {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 5;
  min-height: 180px;
  background-color: black;
  overflow: hidden;
  z-index: 1000;
}

.event-banners__carousel,
.event-banners__image {
  height: 100%;
}

@media (max-width: 600px) {
  .event-banners {
    min-height: 120px;
  }
}
</style>
